import { z } from "zod";
import { validateNhsNumber } from "../nhsNumber/validator.js";
// Stryker disable next-line Regex: the ^-anchor and $-anchor mutations are equivalent —
// removing either anchor lets malformed strings past the first refine, but the second
// .refine(validateNhsNumber) independently enforces the same /^\d{10}$/ constraint,
// so the observable rejection result is identical either way.
const NHS_NUMBER_DIGIT_REGEX = /^\d{10}$/;
// Stryker disable next-line Regex: the capture-group quantifier mutation /(\d{3})(\d{3})(\d)/ is
// equivalent — the shorter match leaves the trailing digits unmatched, and String.replace
// appends them verbatim, so both patterns produce the same "012 345 6789" output.
const NHS_NUMBER_FORMAT_REGEX = /(\d{3})(\d{3})(\d{4})/;
export const NhsNumberSchema = z
    .string()
    .transform((val) => val.replace(/\s/g, ""))
    .refine((val) => NHS_NUMBER_DIGIT_REGEX.test(val), {
    message: "NHS Number must be 10 digits",
})
    .refine((val) => validateNhsNumber(val), {
    message: "Invalid NHS Number",
})
    .transform((val) => val.replace(NHS_NUMBER_FORMAT_REGEX, "$1 $2 $3"));
export const NhsNumberRawSchema = z
    .string()
    .transform((val) => val.replace(/\s/g, ""))
    .refine((val) => NHS_NUMBER_DIGIT_REGEX.test(val), {
    message: "NHS Number must be 10 digits",
})
    .refine((val) => validateNhsNumber(val), {
    message: "Invalid NHS Number",
});
//# sourceMappingURL=nhsNumber.js.map